import { Component, OnInit } from '@angular/core';
import { Fields } from 'src/app/shared/models/candidateprofile-genmodel';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: [],
  standalone: false,
})
export class DateComponent implements OnInit {
  field: Fields;
  group: UntypedFormGroup;
  minDate = new Date();
  maxDate: Date;
  constructor() {}

  ngOnInit() {
    // console.log("date----"+ JSON.stringify(this.field));
    if (this.field.value) {
      this.field.value = new Date(this.field.value);
    }
    const current_date = new Date();
    if (this.field.name == 'dob') {
      this.maxDate = new Date(current_date.setFullYear(current_date.getFullYear() - 18));
      this.minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 60));
    }
  }
}
